import { render, staticRenderFns } from "./ContactCustomFields.vue?vue&type=template&id=32321466&scoped=true&"
import script from "./ContactCustomFields.vue?vue&type=script&lang=js&"
export * from "./ContactCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./ContactCustomFields.vue?vue&type=style&index=0&id=32321466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32321466",
  null
  
)

export default component.exports